import { render, staticRenderFns } from "./CareClassification.vue?vue&type=template&id=dc126d4e&"
import script from "./CareClassification.vue?vue&type=script&lang=ts&"
export * from "./CareClassification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc126d4e')) {
      api.createRecord('dc126d4e', component.options)
    } else {
      api.reload('dc126d4e', component.options)
    }
    module.hot.accept("./CareClassification.vue?vue&type=template&id=dc126d4e&", function () {
      api.rerender('dc126d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/CareClassification.vue"
export default component.exports